export class MapMarkerIcon {
  constructor(public url: string, public anchor: google.maps.Point) {}
}
